module.exports = __webpack_public_path__ + "img/north.2d68aeb2.png";